// Klik na riadok zoznamu. Jedno miesto pre vsetky tabulky v admine, aby sa
// spravali rovnako a aby sa nezopakovali tie iste chyby v kazdej sekcii.
//
// Co to riesi:
//  - kliky na odkaz, tlacidlo alebo policko v riadku si riesi ten prvok sam,
//  - oznacovanie textu mysou nesmie otvorit zaznam (clovek si len kopiruje
//    telefon alebo cislo faktury),
//  - ctrl, cmd alebo shift otvori zaznam na novej karte, ak vieme adresu,
//    inak klik proste preskocime.
//
// Pouzitie:
//   onRow={(record) => klikNaRiadok({ akcia: () => otvor(record) })}
//   onRow={(record) => klikNaRiadok({ cesta: `/admin/car/edit/${record.id}`,
//                                     akcia: () => history.push(...) })}
export const klikNaRiadok = ({ akcia, cesta }) => ({
  onClick: (e) => {
    if (typeof akcia !== "function") {
      return;
    }
    const ciel = e?.target;
    if (
      ciel?.closest &&
      ciel.closest(
        "a, button, input, textarea, .ant-checkbox, .ant-select, .ant-dropdown-trigger, .ant-switch"
      )
    ) {
      return;
    }

    let oznaceny = "";
    try {
      oznaceny = window.getSelection ? String(window.getSelection()) : "";
    } catch (chyba) {
      oznaceny = "";
    }
    if (oznaceny.trim().length > 0) {
      return;
    }

    if (e.metaKey || e.ctrlKey || e.shiftKey) {
      if (cesta) {
        window.open(cesta, "_blank", "noopener");
      }
      return;
    }

    akcia(e);
  },
});

export default klikNaRiadok;
